import { HeaderItem } from "@/types/menu";
import { mobileProducts } from "@/lib/product-data/mobile-data";
import { tabletProducts } from "@/lib/product-data/tablet-data";
import { gasProducts } from "@/lib/product-data/gas-detector-data";
import { waterProducts } from "@/lib/product-data/water-logger-data";
import { wirelessCommunicationProducts } from "@/lib/product-data/wireless-communication-data";

export const headerData: HeaderItem[] = [
  { label: "About Us", href: "/" },
  {
    label: "Products",
    href: "#", // Parent item, not clickable
    submenu: [
      {
        label: "Mobile",
        href: "/products/mobile",
        submenu: mobileProducts.map((product) => ({
          label: product.name,
          href: `/products/mobile/${product.id}`,
        })),
      },
      {
        label: "Tablet",
        href: "/products/tablet",
        submenu: tabletProducts.map((product) => ({
          label: product.name,
          href: `/products/tablet/${product.id}`,
        })),
      },
      {
        label: "Wireless Communication",
        href: "/products/wireless",
        submenu: wirelessCommunicationProducts.map((product) => ({
          label: product.name,
          href: `/products/wireless/${product.id}`,
        })),
      },
      {
        label: "Gas Detector",
        href: "/products/gas-detector",
        submenu: gasProducts.map((product) => ({
          label: product.name,
          href: `/products/gas-detector/${product.id}`,
        })),
      },
      {
        label: "Water Logger",
        href: "/products/water-logger",
        submenu: waterProducts.map((product) => ({
          label: product.name,
          href: `/products/water-logger/${product.id}`,
        })),
      },
    ],
  },
  { label: "Contact", href: "/contact" },
  { label: "Careers", href: "/careers" },
];
